namespace TabAurous.Production {
    export namespace MFGInspectionValuesService {
        export const baseUrl = 'Production/MFGInspectionValues';

        export declare function Create(request: Serenity.SaveRequest<MFGInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MFGInspectionValuesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MFGInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MFGInspectionValuesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/MFGInspectionValues/Create",
            Update = "Production/MFGInspectionValues/Update",
            Delete = "Production/MFGInspectionValues/Delete",
            Retrieve = "Production/MFGInspectionValues/Retrieve",
            List = "Production/MFGInspectionValues/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MFGInspectionValuesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
